import { CopyOutlined } from '@ant-design/icons'
import { message } from 'antd'
import copy from 'copy-to-clipboard'

/**
 * Quiet copy icon: no button chrome, no tooltip - just the glyph that copies on click.
 * Use it next to addresses in tables / descriptions where ButtonCopy's hover state
 * and tooltip are too loud.
 */
const CopyIcon = ({ text, title = 'Copy' }: { text: string; title?: string }) => (
  <CopyOutlined
    role="button"
    aria-label={title}
    // primary blue (app.tsx colorPrimary), fixed - no hover colour change, no transition
    style={{ color: '#2b79f7', cursor: 'pointer', fontSize: 14, transition: 'none' }}
    onClick={(e) => {
      e.preventDefault()
      e.stopPropagation()
      copy(text)
      message.success('Copied Success!')
    }}
  />
)

export default CopyIcon
